import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./Step.css'))

type Props = {
  title: string
  notRequired?: boolean
}

const Index: React.FC<Props> = ({ title, notRequired, children }) => {
  return (
    <div className={bem.b('Step').show()}>
      <div
        className={bem
          .b('Step')
          .e('head')
          .show()}
      >
        <h3
          className={bem
            .b('Step')
            .e('title')
            .m('hasRequired', notRequired)
            .show()}
        >
          <FormattedHTMLMessage id={title} />
        </h3>

        {notRequired && (
          <span
            className={bem
              .b('Step')
              .e('not-required')
              .show()}
          >
            <FormattedHTMLMessage id="Brief.notRequired" />
          </span>
        )}
      </div>

      {children}
    </div>
  )
}

Index.defaultProps = {
  notRequired: false
}

export default Index
